module.exports = __webpack_public_path__ + "static/img/concept-pic.53cb57d0.jpg";